import dynamic from 'next/dynamic'
import { Schemas } from '~/api/gen'
import { ShowMoreDescription } from '~/components/modules/ShowMoreDescription/ShowMoreDescription'
import { spCoordinateDetailAds } from '../../data/googleAd'
import { CoordinateComment } from './CoordinateComment'
import { PublishedDate } from './PublishedDate'

const GoogleAd = dynamic(
  () => import('~/features/shared/ad/components/GoogleAd'),
  {
    ssr: false,
  }
)

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
}

export const CoordinateInformation: React.FC<Props> = ({ coordinate }) => {
  return (
    <>
      {coordinate.content && (
        <ShowMoreDescription content={coordinate.content} />
      )}
      <div className="xl:hidden">
        <CoordinateComment coordinate={coordinate} />
        <div className="pb-5 pt-[22px]">
          <GoogleAd elementId={spCoordinateDetailAds.middle} />
        </div>
      </div>
      <div className="pt-1 xl:pt-5">
        <PublishedDate coordinate={coordinate} />
      </div>
    </>
  )
}
